var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHealthcare48Line = function SvgIconHealthcare48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.27 17.22c-1.05-3.39-3.97-5.91-7.42-6.43-2.92-.44-5.8.51-7.85 2.49a9.32 9.32 0 0 0-7.85-2.49c-3.45.52-6.36 3.05-7.42 6.43-1.06 3.41-.14 6.74 2.66 9.64.92.96 6.51 6.55 8.86 8.91 1 1 2.33 1.55 3.75 1.55s2.75-.55 3.75-1.55c3.59-3.6 8.05-8.07 8.86-8.91 2.8-2.9 3.72-6.23 2.66-9.64Zm-5.11 7.28c-.63.65-3.68 3.72-8.83 8.87-.72.72-1.96.72-2.68 0-2.35-2.35-7.92-7.93-8.83-8.87-1.94-2-2.55-4.05-1.86-6.27.67-2.15 2.51-3.75 4.68-4.08.31-.05.62-.07.93-.07 2.03 0 3.88 1.01 4.98 2.77a1.698 1.698 0 0 0 2.88 0c1.27-2.03 3.53-3.06 5.9-2.7 2.17.33 4.01 1.93 4.68 4.08.69 2.21.08 4.26-1.86 6.27h.01Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 18.5h-3.6v3.7h-3.7v3.6h3.7v3.7h3.6v-3.7h3.7v-3.6h-3.7v-3.7Z",
    fill: "current"
  })));
};
export default SvgIconHealthcare48Line;